import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { Menu, Label } from 'semantic-ui-react';

import {
  SHOWROOM,
} from '../constants/apps';

class AppMenu extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    isSiteplan: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.shape({
      appID: PropTypes.string.isRequired,
      webURL: PropTypes.string,
      app: PropTypes.shape({
        shortName: PropTypes.string.isRequired,
      }).isRequired,
    })),
  }
  handlePushLink = (url) => {
    const { store } = this.context;
    store.dispatch(push(url));
  }
  render() {
    const { isSiteplan, apps } = this.props;
    const appsAccess = apps ? apps.filter((app) => {
      if (isSiteplan) {
        return app.hasAccess && app.appID !== SHOWROOM;
      }
      return app.hasAccess;
    }) : [];

    return (
      <Menu secondary>
        {(Array.isArray(appsAccess) && appsAccess.length > 0) ? appsAccess.map(app => (
          <Menu.Item
            key={app.appID}
            name={app.app.shortName}
            href={app.appID !== 'showroom' ? app.webURL : null}
            active={app.appID === 'showroom'}
            onClick={app.appID === 'showroom' ? () => this.handlePushLink('/') : () => {}}
          >
            {app.app.shortName}
            {(app.expiresText) &&
            <p style={{ fontStyle: 'italic', fontSize: '9px' }}>&nbsp;&nbsp;{app.expiresText}</p>
            }
          </Menu.Item>
        )) : null}
      </Menu>
    );
  }
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/AppMenu.jsx